import Cookies from 'js-cookie'

const ANONYMOUS_ID = 'ajs_anonymous_id'

const getAnonymousId = () =>
  Cookies.get(ANONYMOUS_ID)?.replace(/"/g, '') || null

export default getAnonymousId
